/* eslint no-unused-vars: "off" */
import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useIntersectionObserver } from 'usehooks-ts';
import Card from '../_common/card/Card';
import { DateMasks, AnalyticEvents, OvpFeedTypes } from '../../constants';
import { STCOfferCardWrapper, ContentWrapper, Content, Button } from './STCOfferCard.styles';
import OfferDetails from '../_common/offer-details/OfferDetails';
import { formatDate } from '../../services/UtilitiesService';
import { StatusInfo } from '../_common/status-info/StatusInfo';
import TradeCashIcon from '../../assets/TradeCashIcon';
import { NavigateToWindowWithNativeEvents } from '../_common/link/link';

const STCOfferCard = ({ feedData, positionValue }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const {
    id: cardId,
    title,
    callToAction: { title: buttonTextTitle, link },
    content: {
      vehicle: { make },
      appraisal: { carvanaOffer, expirationDate },
    },
  } = feedData;

  let buttonText = buttonTextTitle;
  let nativeNavigationEvent = 'view_offer'; // Default Native Event

  if (buttonTextTitle.toLowerCase() === 'resubmit') {
    buttonText = 'refresh offer';
    nativeNavigationEvent = 'refresh_offer';
  }

  // Redirect to post sale updates page
  const handleRedirect = () => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });

    // Specific Native Events based on the button text
    NavigateToWindowWithNativeEvents({
      url: link,
      event: nativeNavigationEvent,
    });
  };

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  const { type: feedCardType }: any = feedData;
  const expired = feedCardType === OvpFeedTypes.EXPIRED_TRADE;
  const expiryStatus = {
    expired,
    date: formatDate(expirationDate, DateMasks.MMDDYYwSlash),
  };

  const header = {
    title,
    statusInfo: <StatusInfo expiryStatus={expiryStatus} />,
  };

  const appraisalDetails = {
    make,
    carvanaOffer,
    expired,
  };

  return (
    <STCOfferCardWrapper ref={ref}>
      <Card dataQa="stc-offer" header={header} headerIcon={<TradeCashIcon />}>
        <ContentWrapper>
          <Content>
            <OfferDetails appraisalDetails={appraisalDetails} />
          </Content>
          <Button data-testid="stc-offer-cta-button" size="small" onClick={handleRedirect}>
            {buttonText}
          </Button>
        </ContentWrapper>
      </Card>
    </STCOfferCardWrapper>
  );
};

export default STCOfferCard;
